<script setup lang="ts">
import type { TooltipPlacement } from 'vidstack';

import Tooltip from '../Tooltip.vue';
import { localize } from '@/front/composables/StringComposer'
const { tooltipPlacement } = defineProps<{
  tooltipPlacement: TooltipPlacement;
}>();

import { PlayerStore } from '@/front/stores/player_store.js'
const playerStore = PlayerStore()

function handleMousedown() {
  setTimeout(() => {
    localStorage.setItem("volume", playerStore.isMuted ? 0 : playerStore.getVolume)
  }, 100)
}
</script>

<template>
  <Tooltip :placement="tooltipPlacement">
    <template #trigger>
      <media-mute-button
        @mousedown="handleMousedown"
        class="w-8 h-8 @lg/player:w-10 @lg/player:h-10 @2xl/player:w-12 @2xl/player:h-12 ring-media-focus group relative mr-1 inline-flex cursor-pointer items-center justify-center rounded-md outline-none ring-inset hover:bg-white/20 data-[focus]:ring-4"
      >
        <media-icon class="hidden group-data-[state='muted']:block" type="mute" />
        <media-icon class="hidden group-data-[state='low']:block" type="volume-low" />
        <media-icon class="hidden group-data-[state='high']:block" type="volume-high" />
      </media-mute-button>
    </template>

    <template #content>
      <span class="media-muted:hidden">{{ localize('mute') }}</span>
      <span class="media-muted:block hidden">{{ localize('unmute') }}</span>
    </template>
  </Tooltip>
</template>
